import { Box, Tooltip, Typography } from "@mui/material"
import { ErrorFilledOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useShallow } from "zustand/shallow"

import { calculateGoodsReceiptPalletQuantity } from "../../../utils"

import { type GoodsReceiptPallet, IncludeWithEnum } from "@/graphql/codegen/graphql"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"
import { getUomName } from "@/utils/uom"

interface GoodsReceiptPalletProductQtyCellProps {
  pallet: GoodsReceiptPallet
}

export const GoodsReceiptPalletProductQtyCell: FC<GoodsReceiptPalletProductQtyCellProps> = ({ pallet }) => {
  const units = useUnitOfMeasurementsStore(useShallow((s) => s.units))
  const uomName = getUomName(units, pallet.goodsReceiptPalletRow?.product?.packageUsWeightUom)
  const instructions = pallet.goodsReceiptPalletRow?.product?.instructions?.filter((instruction) =>
    instruction.includeWith?.includes(IncludeWithEnum.Putaway)
  )

  const totalPalletUom = calculateGoodsReceiptPalletQuantity(pallet.goodsReceiptPalletRow?.lots ?? [])

  return (
    <Box className='flex flex-col'>
      <Box className='flex items-center gap-1'>
        <Typography variant='body2' className='font-bold text-gray-800'>
          {pallet.goodsReceiptPalletRow?.product?.publicId || "-"}
        </Typography>

        {Boolean(instructions?.length) && (
          <Tooltip
            title={
              <Box className='flex flex-col'>
                <Typography variant='body2' className='font-bold'>
                  Special instructions:
                </Typography>

                {instructions?.map((instruction) => (
                  <Typography key={instruction.instructionId} variant='body2'>
                    {instruction.description}
                  </Typography>
                ))}
              </Box>
            }
            enterTouchDelay={0}
          >
            <ErrorFilledOutlined className='text-red-500' />
          </Tooltip>
        )}
      </Box>

      <Typography variant='body2'>{pallet.goodsReceiptPalletRow?.product?.companyProductDescription || "-"}</Typography>
      <Typography variant='body2'>
        {totalPalletUom} {uomName}
      </Typography>
    </Box>
  )
}
